import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import Wrapper from "../wrapper/Wrapper";
import { Col, Container, Row } from "react-bootstrap";
import LoyaltyLogInForm from "./LoyaltyLogInForm";
import { IoMdClose } from "react-icons/io";
import { scImageType, scLinkType, scStringType } from "../../types";
import { Image } from "@sitecore-jss/sitecore-jss-react";

var LoyaltyLogIn = /*#__PURE__*/function (_Component) {
  _inherits(LoyaltyLogIn, _Component);

  var _super = _createSuper(LoyaltyLogIn);

  function LoyaltyLogIn(props) {
    _classCallCheck(this, LoyaltyLogIn);

    return _super.call(this, props);
  }

  _createClass(LoyaltyLogIn, [{
    key: "render",
    value: function render() {
      var _image, _cancelUrl, _cancelUrl2;

      var handleNoUserFound = this.props.handleNoUserFound;

      var _ref = this.props.model || {},
          image = _ref.image,
          copy = _ref.copy,
          header = _ref.header,
          cancelUrl = _ref.cancelUrl,
          emailPlaceholder = _ref.emailPlaceholder,
          submitLabel = _ref.submitLabel,
          emailValidationError = _ref.emailValidationError;

      image = (_image = image) === null || _image === void 0 ? void 0 : _image.value;
      var description = copy === null || copy === void 0 ? void 0 : copy.value;
      var title = header === null || header === void 0 ? void 0 : header.value;
      cancelUrl = (_cancelUrl = cancelUrl) === null || _cancelUrl === void 0 ? void 0 : _cancelUrl.value;
      var labelEmail = emailPlaceholder === null || emailPlaceholder === void 0 ? void 0 : emailPlaceholder.value;
      var btnText = submitLabel === null || submitLabel === void 0 ? void 0 : submitLabel.value;
      var errorEmail = emailValidationError === null || emailValidationError === void 0 ? void 0 : emailValidationError.value;
      return /*#__PURE__*/React.createElement(Wrapper, {
        className: "loyalty--sign-in"
      }, /*#__PURE__*/React.createElement("a", {
        className: "loyalty--sign-in__close",
        href: (_cancelUrl2 = cancelUrl) === null || _cancelUrl2 === void 0 ? void 0 : _cancelUrl2.href
      }, /*#__PURE__*/React.createElement(IoMdClose, null)), /*#__PURE__*/React.createElement(Container, {
        className: "loyalty--sign-in__container"
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h1", {
        className: "loyalty--sign-in__title"
      }, title), /*#__PURE__*/React.createElement("figure", {
        className: "loyalty--sign-in__image"
      }, /*#__PURE__*/React.createElement(Image, {
        field: image
      })), /*#__PURE__*/React.createElement("p", {
        className: "loyalty--sign-in__description"
      }, description), /*#__PURE__*/React.createElement(LoyaltyLogInForm, {
        errorEmail: errorEmail,
        labelEmail: labelEmail,
        btnText: btnText,
        handleNoUserFound: handleNoUserFound
      })))));
    }
  }]);

  return LoyaltyLogIn;
}(Component);

export default LoyaltyLogIn;